module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "steam-power-plant.18dc4d60.png";